import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { generateInvoice, getFinancialYear } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { getAgentById } from '@/api/agents';
import { getAgentDealers, getDealerCities, searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import Enabled from '@/components/Enabled/index.vue';
import { BranchAgentService } from '@/services/branch-agent-service';
import { isAdmin, isSuperAdmin } from '@/common';
import { averageDealerData, downloadAverageExcel } from '@/api/ledgers';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = '';
    this.branchListLoading = false;
    this.branchList = [];
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.agentList = [];
    this.dealerList = [];
    this.stateList = [];
    this.cityList = [];
    this.agentUserList = [];
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.totalGrandTotal = '';
    this.assignedBranches = [] || null;
    this.showFilters = false;
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      adminId: undefined,
      agentId: undefined,
      agentUserId: undefined,
      stateId: undefined,
      cityId: undefined,
      startDate: undefined,
      endDate: undefined,
      applyBranchIdFilter: true,
      excludeBranches: false,
      branchId: [],
      sort: 'id,ASC',
      assignedAgentsId: undefined,
      forExcel: false
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.loggedInAdmin = null;
    //   getSummaries(param: any) {
    //     const { columns, data } = param;
    //     const sums: any = [];
    //     const totalGrandTotalRow: any = [];
    //     columns.forEach((column: any, index: number) => {
    //       // first column
    //       if (index === 0) {
    //         sums[index] = "Total Page Payments: ";
    //         totalGrandTotalRow[index] = "Grand Total: "; // Add label for the total grand total row
    //         return;
    //       }
    //       // Grand Total column (index 6)
    //       if (index === 7) {
    //         // Get all values for the column at index 6
    //         const values = data.map((item: any) => Number(item[column.property]));
    //         // Check if all values are numbers and calculate the sum
    //         if (!values.every((value: any) => isNaN(value))) {
    //           sums[index] = values.reduce((prev: any, curr: any) => {
    //             const value = Number(curr);
    //             if (!isNaN(value)) {
    //               return prev + curr;
    //             } else {
    //               return prev;
    //             }
    //           }, 0); // initial value
    //           // Use the provided totalGrandTotal to set the value in totalGrandTotalRow
    //           // Ensure `this.totalGrandTotal` is correctly set in the context
    //           totalGrandTotalRow[index] = parseFloat(this.totalGrandTotal).toFixed(
    //             2
    //           );
    //         }
    //       }
    //     });
    //     // Format the sums for index 6 (if necessary)
    //     if (sums[7]) {
    //       sums[7] = sums[7].toFixed(2);
    //     }
    //     // Return sums and total grand total row
    //     return [, , , , , sums, totalGrandTotalRow]; // Return both the sums and total grand total row
    //   }
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin();
  }
  async activated() {
    try {
      if (AdminModule.roles.includes('Read Only')) {
        this.isReadOnly = true;
      }
      //
      // if (!this._isAdminRoles()) {
      this.listQuery.excludeBranches = true;
      // }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.loggedInAdmin = AdminModule;
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
        this.listQuery.agentUserId = this.loggedInAdmin.id;
        if (this.loggedInAdmin.roles.includes('Owner')) {
          this.listQuery.agentUserId = null;
        }
      }
      if (typeof this.listQuery.branchId === 'string' && this.listQuery.branchId.length === 0) {
        delete this.listQuery.branchId;
      }
      if (this.listQuery.dealerId === undefined) {
        delete this.listQuery.dealerId;
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.dateRange = {
          start: this.$route.query.startDate,
          end: this.$route.query.endDate
        };
      }
      if (!this.dateRange) {
        await this.getCurrentFinancialYear();
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      // get dispatch list
      this.getList();
      this.getStateList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      const data = await averageDealerData(this.listQuery);
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getCurrentFinancialYear() {
    const dateData = await getFinancialYear();
    this.dateRange = {
      start: dateData.startDate,
      end: dateData.endDate
    };
    this.listQuery.startDate = this.dateRange.start;
    this.listQuery.endDate = this.dateRange.end;
    // this.getList();
  }
  async handleClearBranch() {
    // Assign branchId using BranchAgentService
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    // Fetch agents for the assigned branchId
    this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        fromDealer: true
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getDealerCityList(params) {
    const data = await getDealerCities(params);
    this.stateList = data.stateList;
    this.cityList = data.cityList;
  }
  async getAgentDealersList(params) {
    const data = await getAgentDealers(params);
    this.dealerList = data;
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.getCityList(this.listQuery.stateId);
    } else {
      // empty city
      this.cityList = [];
      this.listQuery.cityId = undefined;
      this.listQuery.stateId = undefined;
    }
    if (!this.listQuery.cityId) {
      this.listQuery.cityId = undefined;
    }
    if (this.listQuery.dealerId) {
      const params = {
        dealerId: undefined
      };
      params.dealerId = this.listQuery.dealerId;
      this.getDealerCityList(params);
    }
    if (this.listQuery.agentId) {
      const params = {
        agentId: undefined
      };
      params.agentId = this.listQuery.agentId;
      // this.getAgentDealersList(params);
    }
    if (this.listQuery.agentId) {
      const agentData = await getAgentById(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      this.listQuery.forExcel = true;
      const blob = await downloadAverageExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'average-report.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      this.listQuery.forExcel = false;
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'AverageReportList',
  components: {
    Pagination,
    Inr,
    Enabled
  }
})], default_1);
export default default_1;